/**
 * Individual DTF Transfers adapter.
 *
 * This file is loaded only by product.individual-dtf-transfers.json. It uses
 * the public Products 2.0 engine/cart contracts and the public DTF modal
 * sheetOverride contract without changing either protected implementation.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) {
    root.ZugIndividualDtfTransfers = api;
    if (root.document) api.autoInit(root);
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var PLACEHOLDER_PREVIEW = 'individual-dtf-builder-approved';
  var MATERIAL_LABEL = 'DTF Transfer Film';
  var DTF_PROPERTY_KEYS = [
    '_zug_dtf_usage',
    '_zug_dtf_handoff',
    '_zug_dtf_builder',
    '_zug_dtf_job_id',
    '_zug_dtf_note',
    '_zug_dtf_preview',
    '_zug_dtf_sheet_size',
    '_zug_dtf_total_items',
    '_zug_dtf_artwork_count'
  ];

  var MODE_CONFIGS = {
    'small-heat-transfers': {
      mode: 'small',
      label: 'Small Transfers',
      defaultPreset: '2x2',
      presets: [
        { width: 2, height: 2 },
        { width: 2, height: 4 },
        { width: 3, height: 3 },
        { width: 3, height: 4 }
      ]
    },
    'large-heat-transfers': {
      mode: 'large',
      label: 'Large Transfers',
      defaultPreset: '8x8',
      presets: [
        { width: 5, height: 5 },
        { width: 8, height: 8 },
        { width: 10, height: 10 },
        { width: 11, height: 14 }
      ]
    },
    'hat-heat-transfers': {
      mode: 'hat',
      label: 'Hat Transfers',
      defaultPreset: '3x1.25',
      presets: [
        { width: 2, height: 1 },
        { width: 3, height: 1.25 },
        { width: 3.5, height: 1.5 },
        { width: 4, height: 2 },
        { width: 5, height: 2 }
      ]
    }
  };

  function finiteNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function compactNumber(value) {
    var number = finiteNumber(value);
    if (number === null) return '';
    return String(Number(number.toFixed(4)));
  }

  function presetKey(width, height) {
    return compactNumber(width) + 'x' + compactNumber(height);
  }

  function sizeLabel(width, height) {
    return compactNumber(width) + '" × ' + compactNumber(height) + '"';
  }

  function cloneModeConfig(config) {
    if (!config) return null;
    return {
      mode: config.mode,
      label: config.label,
      defaultPreset: config.defaultPreset,
      presets: config.presets.map(function (preset) {
        return { width: preset.width, height: preset.height };
      })
    };
  }

  function getModeConfig(handle, requestedMode) {
    var resolvedMode = String(requestedMode || '').trim();
    if (resolvedMode) {
      var modeKey = Object.keys(MODE_CONFIGS).filter(function (key) {
        return MODE_CONFIGS[key].mode === resolvedMode;
      })[0];
      return cloneModeConfig(modeKey ? MODE_CONFIGS[modeKey] : null);
    }
    return cloneModeConfig(MODE_CONFIGS[String(handle || '').trim()] || null);
  }

  function validateDimensions(width, height, minimum, maximum) {
    var resolvedMinimum = finiteNumber(minimum);
    var resolvedMaximum = finiteNumber(maximum);
    var resolvedWidth = finiteNumber(width);
    var resolvedHeight = finiteNumber(height);
    if (resolvedMinimum === null) resolvedMinimum = 1;
    if (resolvedMaximum === null) resolvedMaximum = 22;

    var valid = resolvedWidth !== null && resolvedHeight !== null &&
      resolvedWidth >= resolvedMinimum && resolvedWidth <= resolvedMaximum &&
      resolvedHeight >= resolvedMinimum && resolvedHeight <= resolvedMaximum;

    return {
      valid: valid,
      width: resolvedWidth,
      height: resolvedHeight,
      minimum: resolvedMinimum,
      maximum: resolvedMaximum,
      message: valid
        ? ''
        : 'Individual DTF width and height must each be between ' +
          compactNumber(resolvedMinimum) + '" and ' + compactNumber(resolvedMaximum) + '".'
    };
  }

  function buildSheetOverride(width, height, minimum, maximum) {
    var validation = validateDimensions(width, height, minimum, maximum);
    if (!validation.valid) return null;
    return {
      width: validation.width,
      height: validation.height,
      margin: 0
    };
  }

  function calculateWithMultiplier(engine, request, multiplier) {
    if (!engine || typeof engine.calculateV2Price !== 'function') return null;
    request = request || {};
    return engine.calculateV2Price(
      request.width,
      request.height,
      request.quantity,
      Number(multiplier),
      request.materialKey,
      request.rushOption
    );
  }

  function resolveLowestCarrier(pricingConfig, variantMap) {
    if (!pricingConfig || !variantMap || !variantMap.base || !variantMap.adjustment) return null;
    var table = pricingConfig.base_unit_price_table || {};
    var best = null;

    Object.keys(variantMap.base).forEach(function (key) {
      var parts = key.split('|');
      if (parts.length !== 2 || !table[parts[0]]) return;
      var price = finiteNumber(table[parts[0]][parts[1]]);
      var variantId = String(variantMap.base[key] || '');
      if (price === null || price <= 0 || !variantId) return;
      if (!best || price < best.unitPrice || (price === best.unitPrice && key < best.key)) {
        best = {
          key: key,
          variantId: variantId,
          unitPrice: price,
          sizeTier: Number(parts[0]),
          quantityBand: Number(parts[1])
        };
      }
    });

    if (!best) return null;
    best.dollarVariantId = String(variantMap.adjustment.dollar || '');
    best.centVariantId = String(variantMap.adjustment.cent || '');
    if (!best.dollarVariantId || !best.centVariantId) return null;
    return best;
  }

  function applyExactCarrier(pricing, carrier) {
    if (!pricing || !carrier) return null;
    var adapted = Object.assign({}, pricing);
    adapted.cart_mode = 'product_single';
    adapted.individual_dtf_carrier = {
      variant_id: carrier.variantId,
      unit_price: carrier.unitPrice,
      source_key: carrier.key
    };
    return adapted;
  }

  function safeParseObject(value) {
    if (!value || typeof value !== 'string') return null;
    try {
      var parsed = JSON.parse(value);
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : null;
    } catch (error) {
      return null;
    }
  }

  function approvedHttpsUrl(value) {
    var text = String(value || '').trim();
    return /^https:\/\//i.test(text) ? text : '';
  }

  function findArtworkReference(builderPayload) {
    var manifest = builderPayload && Array.isArray(builderPayload.assetManifest)
      ? builderPayload.assetManifest
      : [];
    var first = manifest[0] || {};
    return {
      filename: String(first.filename || ''),
      previewUrl: approvedHttpsUrl(first.processedPreviewUrl) || approvedHttpsUrl(first.processedUrl),
      originalUrl: approvedHttpsUrl(first.processedUrl)
    };
  }

  function adaptDtfUpload(rawUpload, context, uploadToken) {
    rawUpload = rawUpload || {};
    context = context || {};
    var upload = Object.assign({}, rawUpload);
    var builderPayload = safeParseObject(upload._zug_dtf_builder);
    var artwork = findArtworkReference(builderPayload);
    var hasPreviewUrl = !!artwork.previewUrl;

    upload.artwork_mode = 'instant_proof';
    upload.upload_id = String(uploadToken || ('individual-dtf-' + Date.now()));
    upload.original_filename = artwork.filename;
    upload.original_url = artwork.originalUrl;
    upload.preview_url = artwork.previewUrl || PLACEHOLDER_PREVIEW;
    upload.approved = true;
    upload.physical_width_in = null;
    upload.physical_height_in = null;
    upload.target_width_in = Number(context.width);
    upload.target_height_in = Number(context.height);
    upload._individual_dtf = 'true';
    upload._individual_dtf_mode = String(context.mode || '');
    upload._individual_dtf_multiplier = Number(context.multiplier).toFixed(2);
    upload._individual_dtf_width = compactNumber(context.width);
    upload._individual_dtf_height = compactNumber(context.height);
    upload._individual_dtf_placeholder_preview = hasPreviewUrl ? 'false' : 'true';
    return upload;
  }

  function augmentSerializedProperties(serialized, upload, context) {
    var output = Object.assign({}, serialized || {});
    upload = upload || {};
    context = context || {};
    if (upload._individual_dtf !== 'true') return output;

    output.Material = MATERIAL_LABEL;
    output['Artwork Status'] = 'Approved';
    delete output.Shape;
    delete output['Easy Peel Tab'];
    if (upload._individual_dtf_placeholder_preview === 'true') {
      delete output['Proof Preview'];
      delete output._dcf_preview_url;
    }

    output._product_family = 'individual_dtf';
    output._individual_dtf = 'true';
    output._individual_dtf_mode = String(context.mode || upload._individual_dtf_mode || '');
    output._individual_dtf_multiplier = Number(
      context.multiplier != null ? context.multiplier : upload._individual_dtf_multiplier
    ).toFixed(2);
    output._individual_dtf_pricing_source = 'products2_v2';
    output._individual_dtf_canvas = compactNumber(context.width || upload._individual_dtf_width) +
      'x' + compactNumber(context.height || upload._individual_dtf_height);
    output._dtf_sheet_width = compactNumber(context.width || upload._individual_dtf_width);
    output._dtf_sheet_height = compactNumber(context.height || upload._individual_dtf_height);

    DTF_PROPERTY_KEYS.forEach(function (key) {
      if (upload[key] !== undefined && upload[key] !== null && upload[key] !== '') {
        output[key] = String(upload[key]);
      }
    });
    return output;
  }

  function buildModalOptions(context, state, callbacks) {
    callbacks = callbacks || {};
    var sheet = buildSheetOverride(state.width, state.height, context.minimum, context.maximum);
    if (!sheet) return null;
    var variantSheetMap = {};
    variantSheetMap[String(context.selectedVariantId || '')] = sheet;
    variantSheetMap[compactNumber(sheet.width) + ' x ' + compactNumber(sheet.height)] = sheet;

    return {
      is_dtf: true,
      product_handle: context.handle,
      variant_id: String(context.selectedVariantId || ''),
      target_width_in: sheet.width,
      target_height_in: sheet.height,
      dtf_config: {
        defaults: {
          sheetWidthInches: sheet.width,
          sheetHeightInches: sheet.height,
          printableMarginInches: 0,
          spacingInches: 0.25,
          assumedInputDpi: 300,
          minimumDpi: 150
        },
        variantSheetMap: variantSheetMap,
        sheetOverride: sheet,
        product: {
          id: context.productId,
          title: context.productTitle,
          handle: context.handle,
          selectedVariantId: String(context.selectedVariantId || ''),
          variants: []
        }
      },
      onSaved: callbacks.onSaved,
      onCancel: callbacks.onCancel,
      onSkip: callbacks.onSkip
    };
  }

  function findActiveRoot(documentObject) {
    if (!documentObject || !documentObject.querySelectorAll) return null;
    var roots = documentObject.querySelectorAll('[data-individual-dtf-adapter][data-ready="true"]');
    for (var index = 0; index < roots.length; index += 1) {
      if (roots[index]._zugIndividualDtfContext) return roots[index];
    }
    return null;
  }

  function installEngineBridge(windowObject) {
    var engine = windowObject && windowObject.ZUG_V2Engine;
    if (!engine || typeof engine.calculateV2Price !== 'function') return false;
    if (engine.calculateV2Price._zugIndividualDtfBridge) return true;

    var original = engine.calculateV2Price;
    function bridgedCalculate(width, height, quantity, materialMultiplier, materialKey, rushOption) {
      var activeRoot = findActiveRoot(windowObject.document);
      if (!activeRoot) return original.apply(this, arguments);
      var context = activeRoot._zugIndividualDtfContext;
      var result = original.call(
        this,
        width,
        height,
        quantity,
        context.multiplier,
        materialKey,
        rushOption
      );
      return applyExactCarrier(result, context.carrier);
    }
    bridgedCalculate._zugIndividualDtfBridge = true;
    bridgedCalculate._zugIndividualDtfOriginal = original;
    engine.calculateV2Price = bridgedCalculate;
    return true;
  }

  function installSerializerBridge(windowObject) {
    var serializer = windowObject && windowObject.ZugLineItemProperties;
    if (!serializer || typeof serializer.serializeProducts2 !== 'function') return false;
    if (serializer.serializeProducts2._zugIndividualDtfBridge) return true;

    var original = serializer.serializeProducts2;
    function bridgedSerialize(options) {
      var serialized = original.apply(this, arguments);
      var upload = options && options.upload;
      if (!upload || upload._individual_dtf !== 'true') return serialized;
      var activeRoot = findActiveRoot(windowObject.document);
      var context = activeRoot ? activeRoot._zugIndividualDtfContext : {};
      return augmentSerializedProperties(serialized, upload, context);
    }
    bridgedSerialize._zugIndividualDtfBridge = true;
    bridgedSerialize._zugIndividualDtfOriginal = original;
    serializer.serializeProducts2 = bridgedSerialize;
    return true;
  }

  function showAdapterError(root, message) {
    var status = root.querySelector('[data-individual-dtf-status]');
    if (status) {
      status.textContent = message;
      status.hidden = false;
    }
  }

  function clearAdapterError(root) {
    var status = root.querySelector('[data-individual-dtf-status]');
    if (status) {
      status.textContent = '';
      status.hidden = true;
    }
  }

  function setCalculatorValidation(context, message) {
    var validation = context.document.getElementById('validation-' + context.sectionId);
    var validationText = context.document.getElementById('validation-text-' + context.sectionId);
    if (validation && validationText) {
      validation.style.display = 'flex';
      validationText.textContent = message;
    }
    if (context.addButton) context.addButton.disabled = true;
  }

  function clearSizeValidation(context) {
    var validation = context.document.getElementById('validation-' + context.sectionId);
    var validationText = context.document.getElementById('validation-text-' + context.sectionId);
    if (validation && validationText && /^Individual DTF/.test(validationText.textContent || '')) {
      validation.style.display = 'none';
      validationText.textContent = '';
    }
  }

  function patchCalculatorCopy(context) {
    var labels = context.calculatorRoot.querySelectorAll('.sticker-calc__price-label');
    labels.forEach(function (label) {
      if (/Price per sticker/i.test(label.textContent || '')) {
        label.textContent = (label.textContent || '').replace(/sticker/i, 'transfer');
      }
    });
    var quantities = context.calculatorRoot.querySelectorAll('.sticker-calc__pricing-qty');
    quantities.forEach(function (quantity) {
      if (/stickers/i.test(quantity.textContent || '')) {
        quantity.textContent = (quantity.textContent || '').replace(/stickers/gi, 'transfers');
      }
    });
  }

  function installCalculatorCopyObserver(context) {
    patchCalculatorCopy(context);
    if (!context.window.MutationObserver) return;
    var observer = new context.window.MutationObserver(function () {
      patchCalculatorCopy(context);
    });
    observer.observe(context.calculatorRoot, { childList: true, subtree: true, characterData: true });
    context.copyObserver = observer;
  }

  function patchBuilderCopy(documentObject) {
    var title = documentObject.getElementById('zug-modal-title');
    if (title && /Build Your Gang Sheet/i.test(title.textContent || '')) {
      title.textContent = 'Build Your Individual Transfer';
    }
    var builder = documentObject.querySelector('[data-dtf-builder-root]');
    if (!builder) return;
    var walker = documentObject.createTreeWalker(builder, 4);
    var node;
    while ((node = walker.nextNode())) {
      var current = node.nodeValue || '';
      var next = current
        .replace(/gang sheet/gi, 'individual transfer')
        .replace(/sheet size/gi, 'transfer size')
        .replace(/sheet usage/gi, 'canvas usage')
        .replace(/ in sheet\b/gi, ' in transfer');
      if (next !== current) node.nodeValue = next;
    }
  }

  function installBuilderCopyObserver(context) {
    patchBuilderCopy(context.document);
    var builder = context.document.querySelector('[data-dtf-builder-root]');
    if (!builder || !context.window.MutationObserver || builder._zugIndividualDtfObserver) return;
    var observer = new context.window.MutationObserver(function () {
      patchBuilderCopy(context.document);
    });
    observer.observe(builder, { childList: true, subtree: true, characterData: true });
    builder._zugIndividualDtfObserver = observer;
  }

  function markPreset(context, key) {
    var buttons = context.document.querySelectorAll('#size-buttons-' + context.sectionId + ' [data-individual-dtf-size]');
    buttons.forEach(function (button) {
      button.classList.toggle('sticker-calc__btn--active', button.getAttribute('data-individual-dtf-size') === key);
    });
  }

  function applySelectedSize(context, width, height, key, showCustom) {
    var validation = validateDimensions(width, height, context.minimum, context.maximum);
    if (!validation.valid) {
      setCalculatorValidation(context, validation.message);
      return false;
    }
    context.window.__ZUG_UPLOAD = null;
    context.calculatorApi.setSize(validation.width, validation.height);
    var customSize = context.document.getElementById('custom-size-' + context.sectionId);
    if (customSize) customSize.style.display = showCustom ? 'block' : 'none';
    markPreset(context, key);
    clearSizeValidation(context);
    patchCalculatorCopy(context);
    return true;
  }

  function renderPresets(context) {
    var container = context.document.getElementById('size-buttons-' + context.sectionId);
    if (!container) return false;
    container.innerHTML = '';

    context.modeConfig.presets.forEach(function (preset) {
      var key = presetKey(preset.width, preset.height);
      var button = context.document.createElement('button');
      button.type = 'button';
      button.className = 'sticker-calc__btn';
      button.setAttribute('data-individual-dtf-size', key);
      button.textContent = sizeLabel(preset.width, preset.height);
      button.addEventListener('click', function () {
        applySelectedSize(context, preset.width, preset.height, key, false);
      });
      container.appendChild(button);
    });

    var customButton = context.document.createElement('button');
    customButton.type = 'button';
    customButton.className = 'sticker-calc__btn';
    customButton.setAttribute('data-individual-dtf-size', 'custom');
    customButton.textContent = 'Custom';
    customButton.addEventListener('click', function () {
      var widthInput = context.document.getElementById('custom-width-' + context.sectionId);
      var heightInput = context.document.getElementById('custom-height-' + context.sectionId);
      applySelectedSize(context, widthInput.value, heightInput.value, 'custom', true);
    });
    container.appendChild(customButton);
    return true;
  }

  function installDimensionBounds(context) {
    var widthInput = context.document.getElementById('custom-width-' + context.sectionId);
    var heightInput = context.document.getElementById('custom-height-' + context.sectionId);
    if (!widthInput || !heightInput) return false;
    [widthInput, heightInput].forEach(function (input) {
      input.min = compactNumber(context.minimum);
      input.max = compactNumber(context.maximum);
      input.step = '0.01';
    });

    function guardInput(event) {
      var validation = validateDimensions(widthInput.value, heightInput.value, context.minimum, context.maximum);
      if (!validation.valid) {
        event.preventDefault();
        event.stopImmediatePropagation();
        setCalculatorValidation(context, validation.message);
        return;
      }
      context.window.setTimeout(function () {
        clearSizeValidation(context);
        markPreset(context, 'custom');
        patchCalculatorCopy(context);
      }, 0);
    }
    widthInput.addEventListener('input', guardInput, true);
    heightInput.addEventListener('input', guardInput, true);
    widthInput.addEventListener('change', guardInput, true);
    heightInput.addEventListener('change', guardInput, true);
    return true;
  }

  function uploadMatchesState(upload, state) {
    if (!upload || upload._individual_dtf !== 'true') return false;
    return Number(upload._individual_dtf_width) === Number(state.width) &&
      Number(upload._individual_dtf_height) === Number(state.height);
  }

  function stopClick(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  function installAddToCartGate(context) {
    var button = context.addButton;
    var originalHtml = button.innerHTML;

    function resetButton() {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.innerHTML = originalHtml;
    }

    context.document.addEventListener('click', function (event) {
      if (event.target !== button && !button.contains(event.target)) return;
      var state = context.calculatorApi.getState();
      var validation = validateDimensions(state.width, state.height, context.minimum, context.maximum);
      if (!validation.valid) {
        stopClick(event);
        setCalculatorValidation(context, validation.message);
        return;
      }

      var priced = context.calculatorApi.applyPhysicalSize(state.width, state.height);
      if (!priced || Math.round(Number(priced.total) * 100) < Math.round(context.carrier.unitPrice * 100)) {
        stopClick(event);
        setCalculatorValidation(context, 'Individual DTF exact-price checkout is unavailable for this selection.');
        return;
      }

      if (uploadMatchesState(context.window.__ZUG_UPLOAD, state)) return;
      stopClick(event);

      if (!context.window.ZUGUploadModal || typeof context.window.ZUGUploadModal.open !== 'function') {
        setCalculatorValidation(context, 'The DTF artwork editor is unavailable. Please reload the page.');
        return;
      }

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Opening DTF artwork editor…';
      var modalOptions = buildModalOptions(context, state, {
        onSaved: function () {
          var rawUpload = context.window.__ZUG_UPLOAD || {};
          context.window.__ZUG_UPLOAD = adaptDtfUpload(rawUpload, {
            mode: context.mode,
            multiplier: context.multiplier,
            width: state.width,
            height: state.height
          });
          context.window.setTimeout(function () {
            context.window.ZUGUploadModal.close('saved');
            resetButton();
            button.click();
          }, 0);
        },
        onCancel: resetButton,
        onSkip: resetButton
      });

      if (!modalOptions) {
        resetButton();
        setCalculatorValidation(context, validation.message);
        return;
      }
      context.window.ZUGUploadModal.open(modalOptions);
      installBuilderCopyObserver(context);
    }, true);
  }

  function failClosed(root, calculatorRoot, message) {
    showAdapterError(root, message);
    if (calculatorRoot) {
      var button = calculatorRoot.querySelector('[id^="add-to-cart-"]');
      if (button) button.disabled = true;
    }
    root.setAttribute('data-ready', 'false');
  }

  function completeInitialization(root, context) {
    var pricingConfig = context.window.ZUG_V2_getConfig();
    var variantMap = context.window.ZUG_V2_getVariantMap();
    var carrier = resolveLowestCarrier(pricingConfig, variantMap);
    if (!carrier) {
      failClosed(root, context.calculatorRoot, 'Individual DTF exact-price carrier configuration is unavailable.');
      return;
    }
    var minTotal = finiteNumber(pricingConfig.min_total) || 15.99;
    if (carrier.unitPrice >= minTotal) {
      failClosed(root, context.calculatorRoot, 'Individual DTF exact-price carrier base is not safely below the minimum order total.');
      return;
    }

    context.carrier = carrier;
    root._zugIndividualDtfContext = context;
    root.setAttribute('data-ready', 'true');
    context.calculatorRoot.setAttribute('data-variant-id', carrier.variantId);
    context.calculatorRoot.setAttribute('data-product-variant-price', carrier.unitPrice.toFixed(2));

    if (!installEngineBridge(context.window) || !installSerializerBridge(context.window)) {
      failClosed(root, context.calculatorRoot, 'Individual DTF could not attach to the existing Products 2.0 contracts.');
      return;
    }
    if (!renderPresets(context) || !installDimensionBounds(context)) {
      failClosed(root, context.calculatorRoot, 'Individual DTF size controls are unavailable.');
      return;
    }

    installCalculatorCopyObserver(context);
    installAddToCartGate(context);
    var defaultPreset = context.modeConfig.presets.filter(function (preset) {
      return presetKey(preset.width, preset.height) === context.modeConfig.defaultPreset;
    })[0] || context.modeConfig.presets[0];
    applySelectedSize(
      context,
      defaultPreset.width,
      defaultPreset.height,
      presetKey(defaultPreset.width, defaultPreset.height),
      false
    );
    clearAdapterError(root);
    context.addButton.disabled = false;
  }

  function initializeRoot(root, windowObject) {
    if (!root || root._zugIndividualDtfInitialized) return;
    root._zugIndividualDtfInitialized = true;
    var documentObject = windowObject.document;
    var handle = String(root.getAttribute('data-product-handle') || '');
    var requestedMode = String(root.getAttribute('data-mode') || '');
    var modeConfig = getModeConfig(handle, requestedMode);
    var calculatorRoot = documentObject.querySelector('.sticker-calc[data-product-handle="' + handle + '"]');

    if (!modeConfig || requestedMode !== modeConfig.mode) {
      failClosed(root, calculatorRoot, 'This Individual DTF template is not configured for the current product.');
      return;
    }
    if (!calculatorRoot) {
      failClosed(root, null, 'The existing Products 2.0 calculator is unavailable.');
      return;
    }

    calculatorRoot.classList.add('sticker-calc--individual-dtf');
    var sectionId = calculatorRoot.id.replace(/^sticker-calculator-/, '');
    var addButton = documentObject.getElementById('add-to-cart-' + sectionId);
    if (!sectionId || !addButton) {
      failClosed(root, calculatorRoot, 'The existing Products 2.0 cart control is unavailable.');
      return;
    }
    addButton.disabled = true;

    var context = {
      window: windowObject,
      document: documentObject,
      root: root,
      calculatorRoot: calculatorRoot,
      calculatorApi: null,
      addButton: addButton,
      sectionId: sectionId,
      handle: handle,
      mode: modeConfig.mode,
      modeConfig: modeConfig,
      productId: root.getAttribute('data-product-id'),
      productTitle: root.getAttribute('data-product-title') || '',
      selectedVariantId: root.getAttribute('data-selected-variant-id') || '',
      minimum: Number(root.getAttribute('data-min-size') || 1),
      maximum: Number(root.getAttribute('data-max-size') || 22),
      multiplier: Number(root.getAttribute('data-pricing-multiplier') || 0.90),
      carrier: null
    };

    var attempts = 0;
    function waitForContracts() {
      attempts += 1;
      context.calculatorApi = windowObject.StickerCalculator && windowObject.StickerCalculator[sectionId];
      var ready = context.calculatorApi &&
        windowObject.ZUG_V2Engine &&
        typeof windowObject.ZUG_V2_getConfig === 'function' &&
        windowObject.ZUG_V2_getConfig() &&
        typeof windowObject.ZUG_V2_getVariantMap === 'function' &&
        windowObject.ZUG_V2_getVariantMap() &&
        windowObject.ZugLineItemProperties &&
        typeof windowObject.ZugLineItemProperties.serializeProducts2 === 'function';
      if (ready) {
        completeInitialization(root, context);
        return;
      }
      if (attempts >= 200) {
        failClosed(root, calculatorRoot, 'Individual DTF timed out while waiting for Products 2.0 pricing.');
        return;
      }
      windowObject.setTimeout(waitForContracts, 50);
    }
    waitForContracts();
  }

  function autoInit(windowObject) {
    function initializeAll() {
      var roots = windowObject.document.querySelectorAll('[data-individual-dtf-adapter]');
      roots.forEach(function (root) { initializeRoot(root, windowObject); });
    }
    if (windowObject.document.readyState === 'loading') {
      windowObject.document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }
    windowObject.document.addEventListener('shopify:section:load', initializeAll);
  }

  return {
    PLACEHOLDER_PREVIEW: PLACEHOLDER_PREVIEW,
    MATERIAL_LABEL: MATERIAL_LABEL,
    getModeConfig: getModeConfig,
    validateDimensions: validateDimensions,
    buildSheetOverride: buildSheetOverride,
    buildModalOptions: buildModalOptions,
    calculateWithMultiplier: calculateWithMultiplier,
    resolveLowestCarrier: resolveLowestCarrier,
    applyExactCarrier: applyExactCarrier,
    adaptDtfUpload: adaptDtfUpload,
    augmentSerializedProperties: augmentSerializedProperties,
    uploadMatchesState: uploadMatchesState,
    installEngineBridge: installEngineBridge,
    installSerializerBridge: installSerializerBridge,
    autoInit: autoInit
  };
});
